export default "__VITE_ASSET__gX4DsWf3__"